<template>
  <div>
    <label class="checkbox">
      <input
        class="checkbox-input"
        type="checkbox"
        v-model="checkbox"
        @click="handleClick"
        :name="label"
        :value="value"
      />
      <div class="checkbox-title">{{ label }}</div>
    </label>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { adobeClickEvent } from "../../../modules/analytics";

export default {
  name: "Checkbox",
  props: {
    value: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    storeKey: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters("selectedFormIds", ["selectedLists"]),
    checkbox: {
      get() {
        return this.selectedLists[this.storeKey];
      },
      set(value) {
        this.$store.dispatch("selectedFormIds/setCheckboxValue", {
          value,
          target: this.storeKey,
        });
      },
    },
  },
  methods: {
    analyze() {
      adobeClickEvent(this.eventId);
    },
    handleClick() {
      this.analyze();
    },
  },
};
</script>
